/**
 * Home page Tokenomics block: supply headline, community reward row, distribution grid, donut asset.
 *
 * Static in-repo — not loaded from Contentful. When removing CMS, do not delete this module or
 * `public/images/tokenomics.webp` / `mproGradient.webp`; update numbers and copy here after PO approval.
 *
 * Consumer: `components/Tokenomics/index.tsx` (also mounted from `views/Home`).
 */
import type { TokenomicsProps } from './types'

export const tokenomicsBaseConfig = {
  supply: '500 000 000',
  communityReward: '253 119 842',
  percentage: 50.62
}

export const tokenomicsConfig: TokenomicsProps[] = [
  {
    amount: '40 000 000',
    title: 'Ecosystem Growth Fund',
    description: 'Cliff & Vesting - on demand',
    percentage: 8
  },
  {
    amount: '54 116 000',
    title: 'Seed sale',
    description: '5% Unlocked at TGE, 3 months cliff,\nrest vested monthly over 12 months',
    percentage: 10.82
  },
  {
    amount: '60 000 000',
    title: 'Liquidty',
    description: 'Cliff & Vesting - on demand',
    percentage: 12
  },
  {
    amount: '35 000 000',
    title: 'Marketing',
    description: '5% Unlocked at TGE,\nrest vested monthly over 24 months',
    percentage: 7
  },
  {
    amount: '25 000 000',
    title: 'Advisors',
    description: '5% Unlocked at TGE, 3 months cliff,\nrest vested monthly over 24 months',
    percentage: 5
  },
  {
    amount: '20 000 000',
    title: 'Foundation',
    description: '6 Months cliff, rest vested monthly\nover 48 months',
    percentage: 4
  },
  {
    amount: '7 764 158',
    title: 'Private round',
    description: '7% Unlocked at TGE, 2 months cliff,\nrest vested monthly over 10 months',
    percentage: 1.55
  },
  {
    amount: '5 000 000',
    title: 'Airdrop',
    description: 'Cliff & Vesting - on demand',
    percentage: 1
  }
]
